const toEnglishDigits = (str) => {
  if (typeof str !== "string") return str;

  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';

  return str
    .replace(/[۰-۹]/g, (w) => persianDigits.indexOf(w))
    .replace(/[٠-٩]/g, (w) => arabicDigits.indexOf(w));
}

const toFarsiDigits = (str, separateThousands = false) => {
  if (typeof str !== "string") return str;

  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  // const arabicDigits  = '٠١٢٣٤٥٦٧٨٩';

  let result = str;

  if (separateThousands) {
    result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    result = result.replace(/\d/g, (d) => persianDigits[d]);
  }
  else {
    result = result.replace(/\d/g, (d) => persianDigits[d]);
  }

  return result;


}


const timeUntil = (dateString) => {

  if (!dateString) {
    return { value: null, unit: null, message: "هنوز ست نشده", original: null };
  }

  const now = new Date();
  const target = new Date(dateString);

  const diffMs = target - now; // اختلاف به میلی‌ثانیه
  if (diffMs <= 0) {
    return { value: 0, unit: "الان", message: "زمان رسیده", original: target };
  }

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays > 0) {
    if (diffDays === 1) {
      return { value: 1, unit: "روز", message: "فردا" , original: target};
    }
    return { value: diffDays, unit: "روز", message: `${diffDays} روز مانده`, original: target };
  }

  if (diffHours > 0) {
    return { value: diffHours, unit: "ساعت", message: `${diffHours} ساعت مانده` , original: target};
  }

  if (diffMinutes > 0) {
    return { value: diffMinutes, unit: "دقیقه", message: `${diffMinutes} دقیقه مانده`, original: target };
  }

  return { value: 0, unit: "الان", message: "الان" , original: target};
}


/**
 * ساخت GUID/UUID نسخه ۴ در سمت کلاینت
 * (برای شناسه‌ی یکتای فاکتور یا کلید idempotency هنگام ارسال به سرور)
 *
 * ترتیب اولویت:
 *   1) crypto.randomUUID  -> استاندارد و در دسترس در مرورگرهای جدید و context امن (https/localhost)
 *   2) crypto.getRandomValues -> ساخت دستی UUIDv4 با اعداد تصادفی امن
 *   3) Math.random -> فقط fallback نهایی (مرورگر قدیمی / context غیرامن)
 *
 * @returns {string} مثال: '3f2b1c9e-7a41-4d6b-9f2e-5c8d0a1b2c3d'
 */
const generateGuid = () => {
  const c = typeof crypto !== 'undefined' ? crypto : null;

  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }

  if (c && typeof c.getRandomValues === 'function') {
    const bytes = c.getRandomValues(new Uint8Array(16));

    // ست کردن بیت‌های نسخه (4) و variant طبق RFC 4122
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');

    return (
      `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-` +
      `${hex.slice(16, 20)}-${hex.slice(20)}`
    );
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * شناسه‌ی فاکتور سمت کلاینت.
 * GUID بدون خط تیره برمی‌گرداند تا در query string و لاگ درگاه‌های پرداخت
 * تمیزتر باشد (طول ۳۲ کاراکتر هگز).
 *
 * @returns {string} مثال: '3f2b1c9e7a414d6b9f2e5c8d0a1b2c3d'
 */
const generateInvoiceId = () => generateGuid().replace(/-/g, '');


/**
 * هدایت کاربر به درگاه پرداخت، مستقل از نوع درگاه.
 *
 * سرور برای همه‌ی درگاه‌ها یک آبجکت یکسان برمی‌گرداند:
 *   { method:'GET',  url:'https://payment.zarinpal.com/...', params:null }
 *   { method:'POST', url:'https://asan.shaparak.ir', params:{ RefId, mobileap } }
 *
 * چرا برای آسان‌پرداخت POST لازم است؟
 * درگاه آسان‌پرداخت با لینک ساده (GET) باز نمی‌شود و حتما باید RefId
 * به‌صورت فیلد فرم و با متد POST ارسال شود. پس به‌جای اینکه سرور HTML
 * بفرستد (که در React قابل اجرا نیست چون اسکریپت داخل innerHTML اجرا نمی‌شود)،
 * خود کلاینت یک فرم موقت می‌سازد و submit می‌کند.
 *
 * @param {{method:string, url:string, params:Object|null}} redirect
 * @returns {boolean} در صورت موفقیت true
 */
const redirectToPaymentGateway = (redirect) => {
  if (!redirect || !redirect.url) {
    console.error('اطلاعات هدایت به درگاه ناقص است', redirect);
    return false;
  }

  const method = String(redirect.method || 'GET').toUpperCase();

  if (method === 'GET') {
    window.location.assign(redirect.url);
    return true;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = redirect.url;
  form.target = '_self';
  form.style.display = 'none';

  Object.entries(redirect.params || {}).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value == null ? '' : String(value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();

  return true;
};


export default {
  toEnglishDigits,
  toFarsiDigits,
  timeUntil,
  generateGuid,
  generateInvoiceId,
  redirectToPaymentGateway

}

